// pages/CreateUnlabelledStock.jsx
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { useDispatch } from "react-redux";

// masters (RTK Query)
import { useGetAllVendorsQuery } from "../toolkitServices/vendorApi";
import { useGetAllBranchesQuery } from "../toolkitServices/branchApi";
import { useGetAllCategoriesQuery } from "../toolkitServices/categoryApi";
import { useGetAllProductsQuery } from "../toolkitServices/productApi";
import { useGetAllPuritiesQuery } from "../toolkitServices/purityApi";
import { useGetAllDesignsQuery } from "../toolkitServices/designApi";
import { useGetAllStonesQuery } from "../toolkitServices/stoneApi";

// push to store
import { setCategoryList } from "../slices/categorySlice";
import { setProductList } from "../slices/productSlice";
import { setVendorList } from "../slices/vendorSlice";
import { setDesignList } from "../slices/designSlice";
import { setPurityList } from "../slices/puritySlice";
import { setBranchList } from "../slices/branchSlice";
import { setStoneList } from "../slices/stoneSlice";

import UnlabelledStockForm from "../components/UnlabelledStockForm";
import { useGetCountersQuery } from "../toolkitServices/counterApi";
import { setCounterList } from "../slices/counterSlice";

const CreateUnlabelledStock = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // fetch masters
  const { data: vendors } = useGetAllVendorsQuery({ page: 1, limit: 100, search: "" });
  const { data: branches } = useGetAllBranchesQuery();
  const { data: categories } = useGetAllCategoriesQuery();
  const { data: products } = useGetAllProductsQuery();
  const { data: designs } = useGetAllDesignsQuery();
  const { data: purities } = useGetAllPuritiesQuery();
  const { data: stones } = useGetAllStonesQuery();
  const { data: counters } = useGetCountersQuery()

  // push masters into store
  useEffect(() => {
    if (categories?.data?.length) dispatch(setCategoryList(categories.data));
    if (products?.data?.length) dispatch(setProductList(products.data));
    if (vendors?.data?.length) dispatch(setVendorList(vendors.data));
    if (designs?.data?.length) dispatch(setDesignList(designs.data));
    if (purities?.data?.length) dispatch(setPurityList(purities.data));
    if (branches?.data?.length) dispatch(setBranchList(branches.data));
    if (stones?.data?.length) dispatch(setStoneList(stones.data));
    if (counters?.data?.length)     dispatch(setCounterList(counters.data));
    
  }, [dispatch, categories, products, vendors, designs, purities, branches, stones,counters]);

  // Ctrl + Backspace -> go back
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "Backspace") {
        e.preventDefault();
        navigate(-1);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className="max-w-8xl mx-auto bg-white shadow-lg rounded-xl overflow-hidden"
    >
    

      {/* Form */}
      <div className="px-2 pt-2 pb-4">
        <UnlabelledStockForm />
      </div>
    </motion.div>
  );
};

export default CreateUnlabelledStock;
